module.exports = __webpack_public_path__ + "img/pizzeriano3-nudeln.54ad2540.jpg";